/*
 * BL-product-addons-v3.js · Carril de GRIFOS agrupado por colección (V4, 2026-07-04/05).
 * SIN pills: UNA FILA (estilo addon original) por colección/familia, máx 3. Cada fila:
 * imagen del grifo preseleccionado → swatches de color (productos, color_main) → ICONOS de
 * tipo (metaobjeto faucets_config, name == valor de la opción `Design`) → toggle propio.
 * Regla condicional (spec Victor): lavabo CON taladro (tapKey 'con') → solo tipos estándar;
 * SIN taladro ('sin') → solo erhöht/Wandmontage. Fuera del modo basin no se filtra.
 * Bundle: provider COMPUESTO (prio 30) en window.__blCartAddonInterceptor que fusiona
 * mueble + lavabo/encimera (window.__blWb3) + grifos togglados + espejos togglados.
 *
 * 2026-08-05 · SELECTOR DE CANTIDAD por fila (spec Victor): default 1, pero si el lavabo
 * seleccionado es de DOS SENOS (window.__blWb3.state.senos === 2, modo basin) el default sube
 * a 2 — dos senos, dos grifos. La cantidad final en carrito es qtyFila × qtyMueble, igual que
 * antes el grifo iba a 1 × qtyMueble. El default automático solo se aplica mientras el cliente
 * no toque el stepper (r.qtyTouched): en cuanto lo toca, su elección manda sobre los senos.
 *
 * 2026-10-08 · RE-AÑADIDO: con el mueble + lavabo/encimera ya en el carrito, un grifo o espejo
 * marcado después entra SOLO, enganchado a ese conjunto, en vez de repetir mueble y lavabo
 * (installReaddGate, al final del fichero; pruebas en tools/BL-addons-readd-harness.js).
 *
 * 2026-10-15 · elegir color o tipo de una fila la ENCIENDE, como si se pulsara su interruptor
 * (switchOn; pruebas en tools/BL-addons-elegir-enciende-harness.js).
 *
 * 2026-10-27 · DIÁLOGO al repetir: con el conjunto ya en el carrito, pulsar añadir pregunta antes
 * («¿añadir otro igual?», o «¿cambiar el grifo o añadir otro conjunto?» si el grifo o el espejo
 * marcado es otro). Se decide al pulsar, con el carrito delante, y la capa de re-añadido recibe
 * la decisión (installReaddDialog; pruebas en tools/BL-addons-readd-dialog-harness.js).
 */
(function () {
  'use strict';

  // 2026-09-01: el snippet de ESPEJOS (BL-product-addons-second-v3.liquid) carga TAMBIEN este
  // fichero, para que el provider compuesto exista aunque el mueble no tenga
  // `custom.addons_collections` y por tanto no haya carril de grifos. Dos etiquetas <script> con
  // la misma URL se ejecutan dos veces; este guard hace inocua la segunda. Va lo primero, antes
  // de cualquier registro, para que no se dupliquen tampoco los listeners de documento.
  if (window.__blAddons3Loaded) return;
  window.__blAddons3Loaded = true;

  var QTY_MIN = 1, QTY_MAX = 10;

  // SIN taladro = SOLO grifo de PARED (Wand/Wandmontage). Regla Victor 2026-07-07: grifo alto
  // (erhöht) es de ENCIMERA con taladro, NO de pared → NO va aquí. Con taladro → alto+bajo (2 iconos);
  // sin taladro/tapa → solo el de pared (1 icono).
  // 2026-08-21: el valor que se mide viene TRADUCIDO por Shopify, así que la lista cubre los
  // idiomas de los markets vivos (de/es/fr/it) — si ninguno casa, el filtro se vacía y allowedDesigns
  // devuelve el juego completo (defensivo), que es peor que acertar pero nunca deja la fila muerta.
  var WALL_RE = /wand|wall|pared|mural|parete/i;
  // 2026-08-31 · el icono de tipo se buscaba SOLO por igualdad exacta del texto, y ese texto llega
  // de DOS fuentes que se traducen POR SEPARADO: el metaobjeto `faucets_config` y el valor de la
  // opcion `Design`. En espanol divergieron por una palabra —"Grifo PARA lavabo elevado" en el
  // metaobjeto contra "Grifo DE lavabo elevado" en la opcion— y el chip del grifo alto salia como
  // TEXTO en vez de con el dibujo; en aleman y frances, con las dos redacciones identicas, casaba.
  // RAISED_RE cubre los idiomas de los markets vivos (de/es/fr) mas it/en, igual que WALL_RE.
  // TEMPORAL (puente hasta la dedupe): cuando alto/regular se deduplique en productos propios el
  // tipo pasara a ser un metafield de producto (`faucet_type` -> metaobjeto, como `color_main`) y
  // se une por `system.handle`; entonces esto desaparece junto con designIdx/allowedDesigns.
  var RAISED_RE = /erh[oö]ht|erhoeht|elevad|sur[eé]lev|surelev|rialzat|raised/i;
  // 2026-08-21 · detección del eje de TIPO sin depender del idioma (ver designIdx). DESIGN_NAME_RE
  // cubre Design/Diseño/Type/Tipo/Typ/Modell/Ausführung; OTHER_AXIS_RE descarta los ejes que NO son
  // el tipo (color y medida) para que el último recurso —"opción única"— no se equivoque de eje.
  var DESIGN_NAME_RE = /design|dise[nñ]|typ|tipo|modell|modelo|ausf[uü]hrung|variante/i;
  var OTHER_AXIS_RE = /farbe|colou?r|gr[oö]sse|größe|breite|width|size|talla|tama[nñ]o|ancho|taille|largeur|titel|title|t[ií]tulo|titre/i;
  var DEFAULT_VALUE_RE = /^default title$/i;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmtCents(c) { try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' }).format(c / 100); } catch (e) { return (c / 100).toFixed(0) + ' €'; } }

  function init() {
    // 2026-08-25 (hardening): el provider COMPUESTO se registra ANTES de pintar los carriles.
    // Estaba al final de init(), detras del forEach: cualquier throw al renderizar (p.ej.
    // [data-a3-rows] ausente por un snippet editado) abortaba el forEach y lo dejaba SIN
    // registrar. Sin el, el /cart/add nativo pasa limpio y el cliente compra el mueble SOLO
    // —sin lavabo, encimera ni grifos, a precio de mueble— sin error visible ni spinner: el
    // fallo mas caro y mas silencioso del carril. Registrarlo primero es seguro porque
    // getBundlePayload lee el estado (__blAddonsV3 / __blWb3) en el momento de la llamada.
    installCompositeProvider();
    document.querySelectorAll('[data-bl-addons3]').forEach(function (root) {
      if (root.dataset.blBound === '1') return;
      root.dataset.blBound = '1';
      var sectionId = root.getAttribute('data-section-id') || '';
      var dataEl = document.getElementById('bl-addons-v3-data-' + sectionId);
      if (!dataEl) return;
      var data; try { data = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }
      var cols = (data.collections || []).filter(function (c) { return (c.products || []).length; });
      if (!cols.length) return;
      // lookup insensible a mayúsculas Y a diacríticos/normalización Unicode:
      // "Erhöht" vs "erhöht", y ö precompuesta (U+00F6) vs o + diéresis combinada (U+0308)
      function normKey(s) {
        s = String(s == null ? '' : s).toLowerCase().trim();
        try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
        return s;
      }
      var typeIcons = {};
      Object.keys(data.typeIcons || {}).forEach(function (k) { typeIcons[normKey(k)] = data.typeIcons[k]; });
      // match ESTRICTO (contrato de siempre). Lo usa designIdx: alli se cuenta cuantos valores de
      // cada eje conoce el metaobjeto para decidir CUAL es el eje de tipo, asi que aflojarlo seria
      // grave — el cubo 'std' es el que absorbe lo no reconocido y haria que un valor de color
      // ("Schwarz", "Chrom") tambien contase como acierto y ganase el eje equivocado.
      function iconFor(d) { return typeIcons[normKey(d)] || null; }

      // 2026-08-31 · segundo intento por CUBO: los DOS lados (entrada del metaobjeto y valor de la
      // opcion) se clasifican con las mismas regex y se unen cubo con cubo, asi que da igual como
      // se redacte cada traduccion. La entrada se clasifica por handle + name: el handle NO se
      // traduce, de modo que el cubo es correcto aunque el metaobjeto no este traducido a un idioma.
      function bucketOf(s) {
        s = String(s == null ? '' : s);
        if (WALL_RE.test(s)) return 'wall';
        if (RAISED_RE.test(s)) return 'raised';
        return 'std';
      }
      // solo se puebla un cubo si UNA sola entrada del metaobjeto cae en el. Si mañana entra un 4o
      // tipo que las regex no saben distinguir, su cubo queda ambiguo y se desactiva SOLO -> vuelve
      // el fallback a texto de siempre, nunca un dibujo equivocado.
      // ⚠️ TRADEOFF ACEPTADO (escenario G del harness): mientras el metaobjeto siga con sus 3
      // entradas, un valor de opcion NUEVO y desconocido cae en el cubo 'std' y recibe el dibujo
      // del grifo estandar en vez de salir como texto. Se asume porque (a) el nombre correcto
      // sigue viendose en la etiqueta de tipo de la fila y en el title/aria-label del chip, y
      // (b) en cuanto se le crea su entrada en el metaobjeto —el paso natural del alta— el cubo
      // 'std' queda ambiguo y se autodesactiva. Si esto molesta, la linea a tocar es la de abajo:
      // limitar el fallback a los cubos positivos ('wall'/'raised') lo elimina, a cambio de dejar
      // el chip estandar otra vez a merced de la traduccion.
      var bucketIcons = {};
      (function () {
        var seen = {};
        (data.typeEntries || []).forEach(function (e) {
          if (!e) return;
          var b = bucketOf((e.handle || '') + ' ' + (e.name || ''));
          seen[b] = (seen[b] || 0) + 1;
          bucketIcons[b] = e.icon || null;
        });
        Object.keys(seen).forEach(function (b) { if (seen[b] > 1) delete bucketIcons[b]; });
      })();
      // match PERMISIVO: exacto primero (gana cuando las traducciones coinciden), cubo despues,
      // y si tampoco, null -> el render cae al fallback de texto que ya existia. Solo lo usa el
      // pintado de chips, nunca la deteccion del eje.
      function iconForRender(d) { return iconFor(d) || bucketIcons[bucketOf(d)] || null; }

      // 2026-08-25 (hardening): sin este guard, un [data-a3-rows] ausente hacia que render()
      // lanzara (rowsEl.querySelector de null) y abortara el forEach. Mismo criterio que los
      // returns de arriba: carril que no se puede pintar → se omite en silencio, sin arrastrar
      // al resto ni al provider del bundle.
      var rowsEl = root.querySelector('[data-a3-rows]');
      if (!rowsEl) return;
      var showPrice = root.getAttribute('data-show-price') !== 'false';
      // etiquetas del stepper: vienen traducidas desde el snippet (claves nativas del tema
      // products.product.quantity.*). '~P~' es el marcador del nombre del grifo — se sustituye
      // aquí porque el título depende del color/fila elegidos, no se sabe en Liquid.
      var L = {
        qty: root.getAttribute('data-qty-label') || 'Menge',
        inc: root.getAttribute('data-qty-inc') || '+',
        dec: root.getAttribute('data-qty-dec') || '-'
      };
      function lblFor(tpl, name) { return String(tpl).split('~P~').join(name || ''); }

      // una fila por colección; estado propio (producto=color, design=tipo, on=toggle, qty=cantidad)
      var rows = cols.map(function (c) {
        return { family: c.handle, col: c, productId: c.products[0] && c.products[0].id, design: null, on: false, qty: QTY_MIN, qtyTouched: false };
      });

      // persistencia entre swaps del grouping (mismo contrato que el selector v3 __blWb3Selection):
      // el grouping recrea el DOM desde HTML cacheado → sin esto los addons se resetean a off cada vez
      // que cambia color/tirador del mueble. Restauramos color/tipo/toggle por FAMILIA si siguen
      // disponibles; si la familia no existe o el color desapareció → default (caída a cascada válida).
      window.__blAddonsV3Selection = window.__blAddonsV3Selection || {};
      (function restoreRows() {
        var saved = window.__blAddonsV3Selection[sectionId]; if (!saved) return;
        rows.forEach(function (r) {
          var s = saved[r.family]; if (!s) return;
          if (s.productId != null && r.col.products.some(function (p) { return p.id === s.productId; })) r.productId = s.productId;
          if (s.design != null) r.design = s.design;   // si ya no está permitido, render() lo baja a default
          r.on = !!s.on;
          r.qtyTouched = !!s.qtyTouched;
          // solo respetamos la cantidad guardada si fue MANUAL; si venía del automático por senos
          // la recalculamos, porque el swap puede haber cambiado el lavabo (1↔2 senos)
          if (r.qtyTouched) r.qty = clampQty(s.qty);
        });
      })();

      function prod(r) { return r.col.products.find(function (p) { return p.id === r.productId; }) || r.col.products[0]; }
      // valores distintos del eje `i` (sin la opción por defecto de los productos de 1 variante)
      function optValues(p, i) {
        var seen = {}, out = [];
        (p.variants || []).forEach(function (v) {
          var val = v.opts && v.opts[i];
          if (!val || DEFAULT_VALUE_RE.test(val) || seen[val]) return;
          seen[val] = 1; out.push(val);
        });
        return out;
      }
      // 2026-08-21 · el eje de tipo YA NO se busca por el nombre literal "Design". Shopify sirve los
      // nombres de opción TRADUCIDOS (Translate & Adapt): en español llega "Diseño", el viejo
      // /design/i no casaba y designIdx quedaba en -1 → la fila salía SIN iconos de tipo, sin la
      // etiqueta del tipo y con la variante resuelta a la 1ª disponible (el cliente español no podía
      // elegir alto/bajo/pared; en alemán, con la opción sin traducir, todo funcionaba). Orden:
      //   1) el eje cuyos VALORES conoce el metaobjeto faucets_config (typeIcons) — la vía normal,
      //      independiente del idioma mientras metaobjeto y opciones se traduzcan a la vez;
      //   2) el nombre de la opción contra una lista multi-idioma;
      //   3) la única opción del producto, si no es color/medida ni la Title por defecto.
      // Sin coincidencia devuelve -1 y el carril degrada como siempre (fila sin iconos, 1ª variante).
      function designIdx(p) {
        var names = p.optionNames || [];
        if (!names.length) return -1;
        var best = -1, bestHits = 0;
        for (var i = 0; i < names.length; i++) {
          var hits = 0;
          optValues(p, i).forEach(function (v) { if (iconFor(v)) hits++; });
          if (hits > bestHits) { bestHits = hits; best = i; }
        }
        if (best >= 0) return best;
        for (var j = 0; j < names.length; j++) {
          if (DESIGN_NAME_RE.test(names[j]) && !OTHER_AXIS_RE.test(names[j])) return j;
        }
        if (names.length === 1 && !OTHER_AXIS_RE.test(names[0]) && optValues(p, 0).length) return 0;
        return -1;
      }
      function designValues(p) {
        var di = designIdx(p); if (di < 0) return [];
        return optValues(p, di);
      }
      // regla condicional por modo del selector v3 (Victor 2026-07-07):
      //   con lavabo + CON taladro → grifos de encimera (alto + bajo), 2 iconos
      //   con lavabo SIN taladro / solo encimera (tapa) → grifo de PARED (Wand), 1 icono
      //   sin lavabo / sin selector → estándar de encimera (95% ventas)
      function isWallCase() {
        var wb3 = window.__blWb3;
        if (!wb3) return false;
        if (wb3.mode === 'top') return true;                                     // solo tapa → sin agujero → pared
        if (wb3.mode === 'overtop') return true;                                 // BL-125: lavabo sobre encimera, sin agujero → pared
        if (wb3.mode === 'basin' && wb3.state) return wb3.state.tapKey === 'sin'; // sin taladro → pared
        return false;                                                            // sin lavabo → encimera (95%)
      }
      // cantidad por defecto según el lavabo del selector v3: dos senos → dos grifos.
      // Solo en modo 'basin' (con lavabo): en 'top' (solo encimera) o sin lavabo no hay senos.
      function clampQty(n) { n = parseInt(n, 10); if (!isFinite(n)) n = QTY_MIN; return Math.min(QTY_MAX, Math.max(QTY_MIN, n)); }
      function autoQty() {
        var wb3 = window.__blWb3;
        if (wb3 && wb3.mode === 'basin' && wb3.state && parseInt(wb3.state.senos, 10) === 2) return 2;
        return QTY_MIN;
      }
      // aplica el default automático a las filas que el cliente NO ha tocado; devuelve true si
      // alguna cantidad cambió
      function syncAutoQty() {
        var q = autoQty(), changed = false;
        rows.forEach(function (r) { if (!r.qtyTouched && r.qty !== q) { r.qty = q; changed = true; } });
        return changed;
      }
      function allowedDesigns(p) {
        var all = designValues(p);
        var wall = isWallCase();
        var filtered = all.filter(function (d) { return wall ? WALL_RE.test(d) : !WALL_RE.test(d); });
        return filtered.length ? filtered : all;   // si el filtro vacía, no bloqueamos (defensivo)
      }
      function resolveVariant(r) {
        var p = prod(r); if (!p) return null;
        var di = designIdx(p);
        return (p.variants || []).find(function (x) { return x.available !== false && (di < 0 || x.opts[di] === r.design); }) || null;
      }

      function render() {
        // anti-salto (2026-08-14): si el puntero está sobre una fila, el re-render la
        // reconstruye y el navegador re-aplica :hover un frame tarde → la imagen encogía al
        // tamaño base y volvía a crecer. Marcamos la fila nueva con .bl-hold en el MISMO tick
        // (antes del primer paint → 75px desde el frame 0); se suelta en el mouseout delegado.
        var held = -1;
        var hovEl = rowsEl.querySelector('.bl-addons3__row:hover');
        if (hovEl) held = Array.prototype.indexOf.call(rowsEl.children, hovEl);
        rowsEl.innerHTML = rows.map(function (r, i) {
          var p = prod(r); if (!p) return '';
          r.productId = p.id;
          var designs = allowedDesigns(p);
          if (designs.indexOf(r.design) < 0) r.design = designs[0] || null;
          var v = resolveVariant(r);
          var colorsHtml = r.col.products.map(function (x) {
            var c = x.color || {};
            var sw = c.icon ? ('background-image:url(' + esc(c.icon) + ');background-size:cover;background-position:center')
                            : ('background-color:' + esc(c.hex || '#ddd'));
            return '<button type="button" class="bl-wb3__sw' + (x.id === p.id ? ' is-active' : '') + '" data-a3-row="' + i + '" data-a3-color="' + x.id + '" title="' + esc(c.name || x.title) + '" style="' + sw + '"></button>';
          }).join('');
          // iconos de tipo: con taladro se ven alto+bajo (2, length>1); sin taladro/tapa se ve el de
          // pared (1, forzado por isWallCase para que el cliente VEA qué grifo se lleva aunque sea único)
          var showTypes = isWallCase() || designs.length > 1;
          var typesHtml = showTypes ? designs.map(function (d) {
            var ic = iconForRender(d);
            var inner = ic ? '<img src="' + esc(ic) + '" alt="' + esc(d) + '" loading="lazy">' : '<span>' + esc(d) + '</span>';
            return '<button type="button" class="bl-addons3__ticon' + (d === r.design ? ' is-active' : '') + '" data-a3-row="' + i + '" data-a3-type="' + esc(d) + '" title="' + esc(d) + '" aria-label="' + esc(d) + '">' + inner + '</button>';
          }).join('') : '';
          // título limpio: pdp_title del grifo (o nombre de la colección/familia) + color preseleccionado
          var cname = (p.color && p.color.name) || '';
          var rowTitle = (p.pdpTitle || r.col.title || p.title) + (cname ? ' · ' + cname : '');
          // tipo seleccionado (alto/bajo/pared) en peso normal detrás del título. El texto es el
          // valor de la opción nativa `Design` de la variante: Shopify ya lo sirve TRADUCIDO en el
          // idioma activo (Translate & Adapt → opciones de producto), así que no hay literal en
          // código. Solo cuando la fila muestra iconos de tipo: si el grifo tiene un único diseño
          // estándar no aporta nada (misma lógica que showTypes).
          var typeLabel = showTypes ? r.design : null;
          // stepper de cantidad: default 1, o 2 si el lavabo es de dos senos (ver autoQty)
          var pname = p.pdpTitle || p.title || '';
          var qtyHtml = '<span class="bl-addons3__qty" data-a3-qtywrap="' + i + '" role="group" aria-label="' + esc(L.qty + ' · ' + rowTitle) + '">' +
            '<button type="button" class="bl-addons3__qtybtn" data-a3-qty="' + i + '" data-a3-step="-1" aria-label="' + esc(lblFor(L.dec, pname)) + '"' + (r.qty <= QTY_MIN ? ' disabled' : '') + '>&minus;</button>' +
            '<span class="bl-addons3__qtyval" data-a3-qtyval="' + i + '" aria-live="polite">' + r.qty + '</span>' +
            '<button type="button" class="bl-addons3__qtybtn" data-a3-qty="' + i + '" data-a3-step="1" aria-label="' + esc(lblFor(L.inc, pname)) + '"' + (r.qty >= QTY_MAX ? ' disabled' : '') + '>+</button>' +
          '</span>';
          // layout estilo espejos: imagen | info (título / swatches+precio / [iconos]) | toggle
          // .bl-on: fila togglada → miniatura ampliada de forma persistente (desktop)
          return '<div class="product-addons__item bl-addons3__row' + (r.on ? ' bl-on' : '') + '">' +
            '<div class="product-addons__image">' + (p.image ? '<img class="product-addons__img" src="' + esc(p.image) + '" alt="' + esc(rowTitle) + '" loading="lazy">' : '') + '</div>' +
            '<div class="product-addons__info">' +
              '<strong class="product-addons__title text-sm font-body-bolder">' + esc(rowTitle) +
                (typeLabel ? '<span class="bl-addons3__rowtype"> · ' + esc(typeLabel) + '</span>' : '') +
              '</strong>' +
              '<span class="bl-addons3__line2">' +
                '<span class="bl-addons3__sws">' + colorsHtml + '</span>' +
                (typesHtml ? '<span class="bl-addons3__chips">' + typesHtml + '</span>' : '') +
                qtyHtml +
                // el precio de la fila es el de la LÍNEA (unidad × cantidad): con el stepper al lado
                // es lo que el cliente espera ver sumado en el sticky
                (showPrice && v ? '<span class="product-addons__price">+' + fmtCents(parseFloat(v.price) * r.qty) + '</span>' : '') +
              '</span>' +
            '</div>' +
            '<div class="product-addons__toggle-wrapper"><label class="product-addons__switch">' +
              '<input type="checkbox" class="product-addons__toggle bl-addons3__toggle" data-a3-toggle="' + i + '"' + (r.on ? ' checked' : '') + ' aria-label="' + esc(p.title) + '">' +
              '<span class="product-addons__slider" aria-hidden="true"></span>' +
            '</label></div>' +
          '</div>';
        }).join('');
        if (held > -1 && rowsEl.children[held]) rowsEl.children[held].classList.add('bl-hold');
        publish();
      }

      // refresca SOLO lo que depende de la cantidad (valor, botones tope y precio de línea).
      // Evitamos render() completo para no reconstruir la imagen del grifo en cada +/-.
      function syncQtyRow(i) {
        var r = rows[i]; if (!r) return;
        var wrap = rowsEl.querySelector('[data-a3-qtywrap="' + i + '"]'); if (!wrap) return;
        var val = wrap.querySelector('[data-a3-qtyval="' + i + '"]');
        if (val) val.textContent = r.qty;
        wrap.querySelectorAll('[data-a3-step]').forEach(function (b) {
          var st = +b.getAttribute('data-a3-step');
          b.disabled = st < 0 ? r.qty <= QTY_MIN : r.qty >= QTY_MAX;
        });
        var rowEl = wrap.closest('.bl-addons3__row');
        var priceEl = rowEl && rowEl.querySelector('.product-addons__price');
        var v = resolveVariant(r);
        if (priceEl && v) priceEl.textContent = '+' + fmtCents(parseFloat(v.price) * r.qty);
      }

      // expone la selección por fila para el provider compuesto + evento + precio global
      function publish() {
        window.__blAddonsV3 = window.__blAddonsV3 || {};
        window.__blAddonsV3Selection = window.__blAddonsV3Selection || {};
        var snap = window.__blAddonsV3Selection[sectionId] = {};   // snapshot para restaurar tras swap
        rows.forEach(function (r) {
          window.__blAddonsV3[sectionId + '|' + r.family] = {
            on: r.on, qty: r.qty, variant: r.on ? resolveVariant(r) : null, product: prod(r), family: r.family
          };
          snap[r.family] = { productId: r.productId, design: r.design, on: r.on, qty: r.qty, qtyTouched: r.qtyTouched };
        });
        root.dispatchEvent(new CustomEvent('bl:addons3:change', { bubbles: true, detail: window.__blAddonsV3 }));
      }

      // 2026-10-15 · elegir color o tipo ENCIENDE la fila. Antes solo cambiaba la foto y el precio
      // de la fila: el interruptor seguía apagado, el botón de añadir con el precio sin grifo, y
      // el conjunto entraba sin él (9→15-10: 17 conjuntos tocaron color o tipo sin encenderlo y 11
      // entraron sin grifo). Se marca el checkbox y se dispara su `change`, o sea, el mismo camino
      // que un toque en el interruptor: estado y clase bl-on (listener de abajo), publish() con el
      // precio del botón y __blAddonsV3Selection, y `addon_changed` 'on' en BL-posthog.js. Apagar
      // sigue siendo solo con el interruptor. Fila ya encendida o sin variante a la venta: nada.
      function switchOn(i) {
        var r = rows[i]; if (!r || r.on || !resolveVariant(r)) return;
        var t = rowsEl.querySelector('[data-a3-toggle="' + i + '"]');
        if (!t || t.disabled) return;
        t.checked = true;
        t.dispatchEvent(new Event('change', { bubbles: true }));
      }

      root.addEventListener('click', function (e) {
        var col = e.target.closest('[data-a3-color]');
        if (col) {
          var ri = +col.getAttribute('data-a3-row');
          var pid = parseInt(col.getAttribute('data-a3-color'), 10);
          rows[ri].productId = pid;
          render();
          switchOn(ri);
          // móvil (sin hover): la miniatura (ya con el color nuevo) crece 2s y vuelve
          if (window.matchMedia && window.matchMedia('(hover: none)').matches) {
            var sw = root.querySelector('.bl-wb3__sw[data-a3-row="' + ri + '"]');
            var rowEl = sw && sw.closest('.bl-addons3__row');
            if (rowEl) {
              rowEl.classList.add('bl-zoom');
              setTimeout(function () { rowEl.classList.remove('bl-zoom'); }, 2000);
            }
          }
          return;
        }
        var typ = e.target.closest('[data-a3-type]');
        if (typ) { var ti = +typ.getAttribute('data-a3-row'); rows[ti].design = typ.getAttribute('data-a3-type'); render(); switchOn(ti); return; }
        var qb = e.target.closest('[data-a3-qty]');
        if (qb) {
          var qi = +qb.getAttribute('data-a3-qty');
          var r2 = rows[qi]; if (!r2) return;
          var next = clampQty(r2.qty + (+qb.getAttribute('data-a3-step') || 0));
          if (next === r2.qty) return;
          r2.qty = next;
          r2.qtyTouched = true;   // a partir de aquí manda el cliente, no el nº de senos
          syncQtyRow(qi);         // update quirúrgico: sin repintar la fila (no recarga la imagen)
          publish();
          return;
        }
      });
      root.addEventListener('change', function (e) {
        var t = e.target.closest('[data-a3-toggle]');
        if (t) {
          var r = rows[+t.getAttribute('data-a3-toggle')];
          r.on = !!t.checked;
          // fila marcada → miniatura ampliada persistente (y al desmarcar vuelve al hover normal)
          var rowEl = t.closest('.bl-addons3__row');
          if (rowEl) rowEl.classList.toggle('bl-on', r.on);
          publish();
        }
      });

      // desktop: la imagen CAMBIA al color bajo el cursor (solo cambia el `src`, sin reflujo).
      // El TAMAÑO lo controla el `:hover` de la fila en CSS (estable) — aquí NO tocamos tamaño.
      // hoverImg recuerda la imagen que estamos previsualizando para revertir al color elegido.
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        root.addEventListener('mouseover', function (e) {
          var sw = e.target.closest('.bl-wb3__sw[data-a3-color]');
          if (!sw || sw.disabled) return;
          var r = rows[+sw.getAttribute('data-a3-row')]; if (!r) return;
          var pid = parseInt(sw.getAttribute('data-a3-color'), 10);
          var hovered = r.col.products.find(function (x) { return x.id === pid; });
          var rowEl = sw.closest('.bl-addons3__row');
          var img = rowEl && rowEl.querySelector('.product-addons__img');
          if (img && hovered && hovered.image) img.src = hovered.image;
        });
        // al salir del bloque de swatches (no al deslizar entre ellos) → volver al color elegido
        root.addEventListener('mouseout', function (e) {
          var sw = e.target.closest('.bl-wb3__sw[data-a3-color]');
          if (!sw) return;
          var to = e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.bl-wb3__sw[data-a3-color]');
          if (to) return;
          var r = rows[+sw.getAttribute('data-a3-row')]; if (!r) return;
          var rowEl = sw.closest('.bl-addons3__row');
          var img = rowEl && rowEl.querySelector('.product-addons__img');
          var cur = prod(r);
          if (img && cur && cur.image) img.src = cur.image;
        });
        // suelta el hold anti-salto al salir el puntero de la fila (mouseleave no burbujea,
        // y el listener debe ser delegado porque render() reemplaza los nodos)
        root.addEventListener('mouseout', function (e) {
          var rowEl = e.target.closest('.bl-addons3__row');
          if (!rowEl || !rowEl.classList.contains('bl-hold')) return;
          if (e.relatedTarget && rowEl.contains(e.relatedTarget)) return;
          rowEl.classList.remove('bl-hold');
        });
        // precarga las imágenes de todos los colores para que el cambio sea instantáneo
        rows.forEach(function (r) {
          r.col.products.forEach(function (x) { if (x.image) { var im = new Image(); im.src = x.image; } });
        });
      }

      // re-filtrar tipos cuando cambia el lavabo (taladro/modo) y re-aplicar la cantidad por senos
      document.addEventListener('bl:wb3:change', function () { syncAutoQty(); render(); });

      // primer pintado: el selector v3 puede no haber resuelto todavía (__blWb3 aún vacío) — no
      // pasa nada, su primer bl:wb3:change vuelve a pasar por syncAutoQty y corrige la cantidad
      syncAutoQty();
      render();
    });
  }

  // -------- provider COMPUESTO (prio 30): mueble + lavabo/encimera + grifos + espejos togglados --------
  function installCompositeProvider() {
    if (!window.__blCartAddonInterceptor) window.__blCartAddonInterceptor = { installed: false, originalFetch: window.fetch.bind(window), providers: new Map() };
    var reg = window.__blCartAddonInterceptor;
    if (!reg.installed) {
      reg.installed = true;
      window.fetch = function (url, config) {
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        if (u.indexOf('/cart/add') < 0 || !config) return reg.originalFetch.call(this, url, config);
        var provs = Array.from(reg.providers.values()).sort(function (a, b) { return (b.priority || 0) - (a.priority || 0); });
        for (var i = 0; i < provs.length; i++) {
          // 2026-08-25 (hardening): un throw aqui saldria SINCRONO por window.fetch y el
          // .catch() del tema no lo veria → boton de ATC colgado. Degradar a "sin bundle".
          var pl = null;
          try { pl = provs[i] && provs[i].getBundlePayload && provs[i].getBundlePayload(config); }
          catch (e) { pl = null; }
          if (!pl || !Array.isArray(pl.items) || !pl.items.length) continue;
          var nc = Object.assign({}, config);
          nc.headers = Object.assign({}, config.headers || {}, { 'Content-Type': 'application/json', 'Accept': 'application/json' });
          nc.body = JSON.stringify({ items: pl.items, sections: pl.sections || '', sections_url: pl.sectionsUrl || window.location.pathname });
          return reg.originalFetch.call(this, url, nc);
        }
        return reg.originalFetch.call(this, url, config);
      };
    }
    if (reg.providers.has('bl-addons3:composite')) return;

    function parseMain(config) {
      var body = config && config.body, mainId, qty = 1, sections = '', sectionsUrl = '', props = {};
      if (body instanceof FormData) {
        mainId = body.get('id'); qty = parseInt(body.get('quantity') || 1, 10) || 1;
        sections = body.get('sections') || ''; sectionsUrl = body.get('sections_url') || window.location.pathname;
        body.forEach(function (val, key) { if (key.indexOf('properties[') === 0) { var m = key.match(/properties\[(.*?)\]/); if (m) props[m[1]] = val; } });
      } else if (typeof body === 'string') {
        try { var b = JSON.parse(body); mainId = b.id || (b.items && b.items[0] && b.items[0].id); qty = parseInt(b.quantity || (b.items && b.items[0] && b.items[0].quantity) || 1, 10) || 1; sections = b.sections || ''; sectionsUrl = b.sections_url || window.location.pathname; props = Object.assign({}, b.properties || (b.items && b.items[0] && b.items[0].properties) || {}); } catch (e) { return null; }
      } else return null;
      if (!mainId) return null;
      return { id: mainId, qty: qty, sections: sections, sectionsUrl: sectionsUrl, props: props };
    }

    reg.providers.set('bl-addons3:composite', { priority: 30, getBundlePayload: function (config) {
      // 2026-07-29: gates de VIDA — tras un swap del grouping a una PDP sin contexto v3 (p.ej.
      // v3→v2, templates distintos) los globales __blWb3/__blAddonsV3 quedan huérfanos y este
      // provider (prio 30, gana siempre) inyectaba el lavabo/grifo del producto ANTERIOR en el add.
      // Sin bloque v3 vivo en el DOM se abstiene y deja pasar a los providers del template v2.
      var hasWb3Block = !!document.querySelector('[data-bl-wb3]');
      var hasFaucetRail = !!document.querySelector('[data-bl-addons3]');
      // 2026-09-01: el carril de ESPEJOS v3 tambien cuenta como contexto v3 vivo. Sin esta
      // tercera condicion, un mueble con espejos pero sin grifos abortaba aqui y el espejo
      // togglado no llegaba al /cart/add: el cliente pagaba el mueble solo, sin error visible.
      var hasMirrorRail = !!document.querySelector('[data-bl-addons2]');
      if (!hasWb3Block && !hasFaucetRail && !hasMirrorRail) return null;
      var main = parseMain(config); if (!main) return null;
      var addons = [];
      // 1) lavabo o encimera del selector v3 (LIGADOS al mueble en carrito)
      var wb3 = hasWb3Block ? window.__blWb3 : null;
      if (wb3 && wb3.variant && wb3.variant.id && wb3.variant.available !== false) {
        var flag = wb3.mode === 'top' ? '_is_vanity_top' : '_is_washbasin';
        var wprops = {}; wprops[flag] = 'true';
        addons.push({ id: parseInt(wb3.variant.id, 10), props: wprops });
        // 2026-09-17: miniatura del mueble en carrito = foto del mueble con ESTE lavabo/encimera
        // (ver buildBundle en BL-washbasin-selector-v3.js). Solo si el lavabo viaja de verdad.
        if (wb3.heroMediaId) main.props._bl_hero_media = String(wb3.heroMediaId);
      }
      // 2) grifos togglados del carril v3 (addons REALES, línea independiente)
      // qty: cantidad elegida en el stepper de la fila (default 1, o 2 con lavabo de dos senos).
      // Se multiplica por la del mueble más abajo → 2 senos × 2 muebles = 4 grifos.
      var a3 = hasFaucetRail ? (window.__blAddonsV3 || {}) : {};
      Object.keys(a3).forEach(function (k) {
        var s = a3[k];
        if (s && s.on && s.variant && s.variant.id && s.variant.available !== false) addons.push({ id: parseInt(s.variant.id, 10), qty: s.qty, props: { _is_faucet: 'true' } });
      });
      // 3) espejos del carril v3 (BL-product-addons-second-v3): variante ya resuelta a la talla
      // del mueble y cantidad propia del stepper, igual que los grifos.
      var a2 = hasMirrorRail ? (window.__blAddonsSecond || {}) : {};
      Object.keys(a2).forEach(function (k) {
        var s = a2[k];
        if (s && s.on && s.variant && s.variant.id && s.variant.available !== false) addons.push({ id: parseInt(s.variant.id, 10), qty: s.qty, props: { _is_mirror: 'true' } });
      });
      // 4) espejos del carril CLASICO (bloque BL-product-addons, plantillas v2): toggles marcados
      document.querySelectorAll('[data-product-addons] .product-addons__toggle:checked').forEach(function (t) {
        if (t.closest('[data-bl-addons3]')) return;   // los toggles del carril grifos ya van por __blAddonsV3
        if (t.closest('[data-bl-addons2]')) return;   // ni los del carril de espejos v3, ya contados arriba
        var vid = parseInt(t.getAttribute('data-addon-variant-id'), 10);
        if (vid) addons.push({ id: vid, props: { _isAddon: 'true' } });
      });
      if (!addons.length) return null;   // nada seleccionado → add nativo / providers inferiores
      var ids = addons.map(function (a) { return a.id; });
      var bid = 'blset_' + String(main.id) + '_' + ids.slice().sort().join('-');
      main.props._msw_bundle_id = bid; main.props._linkedTo = ids.join(',');
      var items = [{ id: parseInt(main.id, 10), quantity: main.qty, properties: main.props }];
      addons.forEach(function (a) {
        var p = Object.assign({ _msw_bundle_id: bid, _linkedTo: String(main.id) }, a.props);
        // el lavabo/encimera va 1:1 con el mueble (sin `qty`); grifos y espejos v3 llevan la
        // cantidad de su stepper, siempre multiplicada por la cantidad de muebles
        var n = parseInt(a.qty, 10); if (!isFinite(n) || n < 1) n = 1;
        items.push({ id: a.id, quantity: main.qty * n, properties: p });
      });
      // 2026-09-01 (pedido de Victor): orden en carrito = mueble, lavabo/encimera, grifo, espejo.
      // Shopify lista las lineas de la MAS RECIENTE a la mas antigua y un /cart/add con items[]
      // las da de alta en el orden del array (comprobado contra la tienda: [1,2,3,4] sale 4,3,2,1),
      // asi que el payload viaja INVERTIDO: [espejos, grifos, lavabo, mueble]. Asi el orden es el
      // bueno en drawer, /cart, checkout y cart.items.first (recomendaciones), sin depender del
      // reorder por roles del drawer (cart.js), que solo reordena el DOM.
      items.reverse();
      return { items: items, sections: main.sections, sectionsUrl: main.sectionsUrl };
    } });
    installReaddGate(reg);
    installReaddDialog(reg);
  }

  // -------- RE-AÑADIDO del conjunto (2026-10-08): grifo o espejo marcado DESPUÉS, sin repetir mueble --------
  // El provider compuesto monta SIEMPRE el conjunto entero y no mira el carrito: con mueble +
  // lavabo ya dentro, volver a la ficha, marcar un grifo o un espejo y pulsar añadir metía un
  // SEGUNDO mueble y un SEGUNDO lavabo (el bundle id cambia con los add-ons y Shopify no fusiona).
  // Regla:
  //   1. lo mismo otra vez (este mueble, este lavabo y todo lo marcado ya están en un conjunto del
  //      carrito) → suma a cada línea de ese conjunto; nunca un conjunto aparte.
  //   2. ESTE mueble y ESTE lavabo/encimera ya están en el carrito, en un mismo conjunto, y hay
  //      grifos/espejos marcados que no están en él → entran SOLO esos, enganchados a ese conjunto
  //      (los marcados que ya estaban no se repiten).
  //   3. cambia el lavabo o la encimera → como siempre (segundo conjunto).
  // Todo lo dudoso se queda en «como siempre»: varias unidades en la ficha junto a add-ons nuevos,
  // mueble sin lavabo ni encimera, carril clásico (`_isAddon`), o dos conjuntos del carrito con el
  // mismo mueble y lavabo.
  //
  // POR QUÉ es una capa aparte y no vive en el interceptor de arriba: de ese interceptor hay
  // CUATRO copias (este fichero, BL-washbasin-selector-v3, -v2 y BL-product-addons) y solo se
  // instala la del primer script que carga —en una ficha v3, la del selector de lavabos—. Todas
  // son síncronas y leer el carrito no lo es. Esta capa envuelve al interceptor instalado, sea
  // cual sea, y solo toma el mando cuando la regla 2 aplica; si no, le pasa la llamada intacta.
  //
  // QUÉ llevan los add-ons que entran después: el `_msw_bundle_id` DEL CONJUNTO QUE YA ESTÁ en el
  // carrito (leído de sus líneas, no recalculado) y `_linkedTo` = variante del mueble, igual que
  // cualquier add-on del conjunto. Con eso el carrito los trata como si hubieran entrado a la vez:
  // cart.js los agrupa y ordena por rol dentro del conjunto (data-msw-bundle-id / data-bundle-role),
  // la X del mueble o del lavabo sigue arrastrando solo las piezas ligadas, la X del grifo o del
  // espejo quita solo su línea, y el contador de theme.js no los suma mientras su mueble esté.
  var READD_CART_TIMEOUT_MS = 1200;

  // papel de una línea por sus marcas: MISMA precedencia que cart-drawer.liquid / main-cart.liquid
  function bundleRole(props) {
    props = props || {};
    if (props._is_washbasin === 'true') return 'washbasin';
    if (props._is_vanity_top === 'true') return 'top';
    if (props._is_faucet === 'true') return 'faucet';
    if (props._is_mirror === 'true') return 'mirror';
    if (props._isAddon === 'true') return 'addon';
    return 'main';
  }

  // Parte el payload del provider compuesto en mueble / lavabo o encimera / grifos y espejos.
  // null = este añadido no es candidato a la regla 2: sigue el camino de siempre SIN leer el carrito.
  function readdSplit(pl) {
    if (!pl || !Array.isArray(pl.items)) return null;
    var main = null, bound = null, extras = [], odd = false;
    pl.items.forEach(function (it) {
      var role = bundleRole(it.properties);
      if (role === 'main') { if (main) odd = true; main = it; }
      else if (role === 'washbasin' || role === 'top') { if (bound) odd = true; bound = it; }
      else if (role === 'faucet' || role === 'mirror') extras.push(it);
      else odd = true;   // 'addon' = carril clásico (plantillas v2): fuera de la regla
    });
    if (odd || !main || !bound || !extras.length) return null;
    return { main: main, bound: bound, extras: extras, all: pl.items };
  }

  // Con el carrito delante, qué toca hacer con este añadido. Devuelve SIEMPRE un objeto:
  //   { mode: 'today' }                        → payload completo de siempre
  //   { mode: 'again',  hit, items }           → lo mismo otra vez (regla 1): suma a cada línea
  //   { mode: 'attach', hit, items }           → grifos/espejos nuevos enganchados al conjunto (regla 2)
  //   { mode: 'swap',   hit, items, replaced } → como attach, pero el conjunto YA lleva un grifo (o un
  //                                               espejo) distinto: `replaced` son esas líneas. Sin
  //                                               diálogo se trata como attach (lo de siempre); con
  //                                               diálogo el cliente elige cambiar o añadir otro conjunto.
  // `split.bound` puede faltar (mueble sin lavabo ni encimera: solo desde el diálogo) y `split.extras`
  // puede ir vacío (mueble + lavabo otra vez: idem). La capa de re-añadido sigue entrando solo con
  // readdSplit, que exige las tres piezas, así que su comportamiento no cambia.
  function readdDecide(split, cart) {
    var today = { mode: 'today' };
    if (!split || !cart || !Array.isArray(cart.items)) return today;
    var groups = {};
    cart.items.forEach(function (line) {
      var bid = line && line.properties && line.properties._msw_bundle_id;
      if (bid) (groups[bid] = groups[bid] || []).push(line);
    });
    var boundRole = split.bound ? bundleRole(split.bound.properties) : null, hits = [];
    Object.keys(groups).forEach(function (bid) {
      var mains = groups[bid].filter(function (l) { return bundleRole(l.properties) === 'main'; });
      var bounds = groups[bid].filter(function (l) { var r = bundleRole(l.properties); return r === 'washbasin' || r === 'top'; });
      if (mains.length !== 1) return;
      if (String(mains[0].variant_id) !== String(split.main.id)) return;
      if (split.bound) {
        if (bounds.length !== 1) return;
        if (String(bounds[0].variant_id) !== String(split.bound.id) || bundleRole(bounds[0].properties) !== boundRole) return;
      } else if (bounds.length) return;   // en la ficha sin lavabo y en el carrito con él: otro conjunto
      hits.push({ bid: bid, lines: groups[bid], main: mains[0], bound: bounds[0] || null });
    });
    if (hits.length !== 1) return today;   // ninguno (carrito vacío, otro lavabo…) o varios: ¿a cuál engancharlo?
    var hit = hits[0];
    function lineOf(id) { for (var i = 0; i < hit.lines.length; i++) if (String(hit.lines[i].variant_id) === String(id)) return hit.lines[i]; return null; }
    // de lo marcado, lo que YA está en ese conjunto no se repite: entra solo lo nuevo (conjunto →
    // grifo → espejo, con el grifo todavía marcado en la ficha)
    var fresh = split.extras.filter(function (it) { return !lineOf(it.id); });
    if (!fresh.length) {
      // TODO lo marcado ya está en ese conjunto: es «lo mismo otra vez» → suma a CADA línea que ya
      // existe, no un conjunto aparte. Shopify solo fusiona si variante y propiedades son idénticas,
      // y el id de conjunto que calcula la ficha no coincide con el del carrito cuando los add-ons
      // entraron después: se reenvían las propiedades de las líneas del carrito tal cual.
      var again = [];
      for (var i = 0; i < split.all.length; i++) {
        var line = lineOf(split.all[i].id);
        if (!line) return today;
        again.push({ id: split.all[i].id, quantity: split.all[i].quantity, properties: Object.assign({}, line.properties) });
      }
      return { mode: 'again', hit: hit, items: again };
    }
    if (split.main.quantity !== 1) return today;   // varias unidades de una vez Y add-ons nuevos: dudoso
    var items = fresh.map(function (it) {
      return { id: it.id, quantity: it.quantity, properties: Object.assign({}, it.properties, { _msw_bundle_id: hit.bid }) };
    });
    // ¿el conjunto ya lleva una pieza del MISMO papel que alguna de las nuevas y que ya no está
    // marcada? Es un cambio de grifo o de espejo, no un grifo más.
    var freshRoles = {};
    fresh.forEach(function (it) { freshRoles[bundleRole(it.properties)] = true; });
    var replaced = hit.lines.filter(function (l) {
      var r = bundleRole(l.properties);
      if ((r !== 'faucet' && r !== 'mirror') || !freshRoles[r]) return false;
      return !split.extras.some(function (it) { return String(it.id) === String(l.variant_id); });
    });
    if (!replaced.length) return { mode: 'attach', hit: hit, items: items };
    // la pieza nueva hereda la cantidad de la que sustituye: con el conjunto en ×2 (dos muebles,
    // dos grifos), cambiar de grifo debe dejar dos grifos nuevos, no uno
    var qtyByRole = {};
    replaced.forEach(function (l) { var r = bundleRole(l.properties); qtyByRole[r] = (qtyByRole[r] || 0) + (parseInt(l.quantity, 10) || 0); });
    items = items.map(function (it) {
      var q = qtyByRole[bundleRole(it.properties)];
      return q && q > it.quantity ? Object.assign({}, it, { quantity: q }) : it;
    });
    return { mode: 'swap', hit: hit, items: items, replaced: replaced };
  }

  // Lo de siempre para la capa de re-añadido sin diálogo: null = payload completo; si no, las
  // líneas a enviar (un cambio de grifo entra como grifo más, igual que hasta ahora).
  function readdItems(split, cart) {
    var d = readdDecide(split, cart);
    return d.mode === 'today' ? null : d.items;
  }

  // Quita del carrito las líneas que el cliente cambia (cambio de grifo o de espejo): una llamada
  // por línea, en orden, con el mismo prefijo de mercado. Nunca rechaza: si una falla, se sigue
  // (lo peor que puede pasar es lo de siempre, el grifo viejo se queda y el cliente lo quita a mano).
  function removeCartLines(reg, lines) {
    var root = cartRoot();
    return lines.reduce(function (chain, line) {
      return chain.then(function () {
        if (!line || !line.key) return null;
        return reg.originalFetch.call(window, root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function (r) { return r && r.ok ? r.json() : null; }).catch(function () { return null; });
      });
    }, Promise.resolve(null));
  }

  function cartRoot() {
    // con el prefijo de mercado (/es-es/, /fr-fr/…), como el resto de llamadas al carrito del tema
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  // Lee el carrito con tope de tiempo. NUNCA rechaza: fallo de red, respuesta rara o tardanza
  // resuelven a null, que es «no sé qué hay en el carrito» → payload completo de siempre.
  function readCartForReadd(reg) {
    return new Promise(function (resolve) {
      var done = false;
      function finish(cart) { if (done) return; done = true; clearTimeout(timer); resolve(cart || null); }
      var timer = setTimeout(function () { finish(null); }, READD_CART_TIMEOUT_MS);
      try {
        reg.originalFetch.call(window, cartRoot() + 'cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r && r.ok ? r.json() : null; })
          .then(finish, function () { finish(null); });
      } catch (e) { finish(null); }
    });
  }

  // La decisión que dejó el diálogo para el siguiente /cart/add de ESTE mueble, si es reciente.
  // Se consume al leerla: el añadido siguiente vuelve a decidir con el carrito.
  var READD_DECISION_TTL_MS = 15000;
  function takeReaddDecision(reg, pl) {
    var d = reg.readdDecision;
    if (!d) return null;
    reg.readdDecision = null;
    if (!pl || !Array.isArray(pl.items)) return null;
    if (Date.now() - d.at > READD_DECISION_TTL_MS) return null;
    var main = null;
    pl.items.forEach(function (it) { if (bundleRole(it.properties) === 'main') main = it; });
    if (!main || String(main.id) !== String(d.mainId)) return null;
    return d;
  }

  function installReaddGate(reg) {
    if (reg.readdInstalled) return;
    reg.readdInstalled = true;
    var inner = window.fetch;   // el interceptor instalado: el de arriba o el de otro fichero
    window.fetch = function (url, config) {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (u.indexOf('/cart/add') < 0 || !config) return inner.call(this, url, config);
      // mismo criterio que el hardening del 25-08: de aquí no sale un throw síncrono ni una
      // promesa colgada. Cualquier tropiezo acaba en inner(), que es exactamente lo de siempre
      // (y nunca en un añadido recortado: perder el mueble o el lavabo es el fallo caro).
      var self = this, pl = null, split = null, dec = null;
      try {
        var prov = reg.providers.get('bl-addons3:composite');
        pl = prov && prov.getBundlePayload(config);
        dec = takeReaddDecision(reg, pl);
        split = dec ? null : readdSplit(pl);
      } catch (e) { split = null; dec = null; }
      if (!split && !dec) return inner.call(this, url, config);
      // sin diálogo: se lee el carrito y se decide como hasta ahora; con diálogo, ya está decidido
      var decided = dec ? Promise.resolve(dec.decision) : readCartForReadd(reg).then(function (cart) {
        var items = null;
        try { items = readdItems(split, cart); } catch (e) { items = null; }
        return items ? { mode: 'attach', items: items } : { mode: 'today' };
      });
      return decided.then(function (d) {
        if (!d || d.mode === 'today' || !Array.isArray(d.items) || !d.items.length) return inner.call(self, url, config);
        function send() {
          // `items` conserva el orden INVERTIDO del payload (espejos, grifos): en el carrito el
          // grifo queda por encima del espejo, como cuando entran con el conjunto
          var nc = Object.assign({}, config);
          nc.headers = Object.assign({}, config.headers || {}, { 'Content-Type': 'application/json', 'Accept': 'application/json' });
          nc.body = JSON.stringify({ items: d.items, sections: pl.sections || '', sections_url: pl.sectionsUrl || window.location.pathname });
          return reg.originalFetch.call(self, url, nc);
        }
        // cambio de grifo o de espejo elegido en el diálogo: primero sale la pieza vieja del
        // conjunto y después entra la nueva, para que el carrito que vuelve ya esté cambiado
        if (d.mode === 'swap' && Array.isArray(d.replaced) && d.replaced.length) return removeCartLines(reg, d.replaced).then(send, send);
        return send();
      });
    };
  }

  // -------- DIÁLOGO al repetir (2026-10-27) --------
  // Por qué aquí y no en la capa de arriba: cuando el /cart/add llega al fetch, el tema ya ha
  // deshabilitado el botón y espera una respuesta de Shopify para pintar el carrito y publicar
  // `product-ajax:added` (que mide PostHog). Un «no, gracias» no tiene respuesta que devolver sin
  // inventársela. Así que la pregunta se hace ANTES: se captura el `submit` del formulario de la
  // ficha, se lee el carrito, se decide, y solo si hay que preguntar se para el envío y se vuelve a
  // enviar con la respuesta. Lo que no es candidato pasa sin tocar.
  //
  // Textos: cada carril (grifos, espejos) deja un <script type="application/json" data-bl-readd-i18n>
  // con las cadenas del idioma de la tienda (locales/*.json, products.product.bl_readd_*).
  function readdI18n() {
    var el = document.querySelector('[data-bl-readd-i18n]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }
  function tpl(str, vars) {
    return String(str == null ? '' : str).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return vars[k] != null ? String(vars[k]) : ''; });
  }
  // Nombre corto para el diálogo: el título del producto hasta la coletilla («Vana Negro incl.
  // válvula de desagüe» → «Vana Negro»). Sin la variante: en el grifo es el tipo («Grifo para
  // lavabo») y en el mueble la medida, que no ayudan a reconocer la pieza.
  var NAME_TAIL_RE = /\s+(incl\.|inkl\.|avec|con|mit|with|–|—|-|\|)\s.*$/i;
  function shortName(s) {
    return String(s == null ? '' : s).replace(/\s+/g, ' ').replace(NAME_TAIL_RE, '').trim();
  }
  function cartLineName(line) {
    return shortName(line && (line.product_title || line.title));
  }
  // Nombre de un grifo o espejo marcado en la ficha, por su variante (del estado que publica cada carril).
  function addonName(variantId, role, i18n) {
    var pools = [window.__blAddonsV3, window.__blAddonsSecond], found = null;
    pools.forEach(function (pool) {
      Object.keys(pool || {}).forEach(function (k) {
        var st = pool[k];
        if (!found && st && st.variant && String(st.variant.id) === String(variantId)) found = st;
      });
    });
    var name = found && found.product && found.product.title;
    if (name) return shortName(name);
    return (i18n && i18n[role]) || role;
  }
  function joinNames(names, i18n) {
    if (names.length <= 1) return names[0] || '';
    return names.slice(0, -1).join(', ') + ' ' + ((i18n && i18n.and) || '&') + ' ' + names[names.length - 1];
  }

  // Como readdSplit, pero para el diálogo: admite mueble sin lavabo y conjunto sin grifos ni espejos.
  function readdSplitAny(pl) {
    if (!pl || !Array.isArray(pl.items)) return null;
    var main = null, bound = null, extras = [], odd = false;
    pl.items.forEach(function (it) {
      var role = bundleRole(it.properties);
      if (role === 'main') { if (main) odd = true; main = it; }
      else if (role === 'washbasin' || role === 'top') { if (bound) odd = true; bound = it; }
      else if (role === 'faucet' || role === 'mirror') extras.push(it);
      else odd = true;
    });
    if (odd || !main) return null;
    return { main: main, bound: bound, extras: extras, all: pl.items };
  }

  var READD_NAME_ORDER = ['faucet', 'mirror'];
  var readdDialogEl = null;
  function readdDialog() {
    if (readdDialogEl && document.body.contains(readdDialogEl)) return readdDialogEl;
    var d = document.createElement('dialog');
    d.className = 'bl-readd';
    d.setAttribute('aria-labelledby', 'bl-readd-title');
    d.innerHTML =
      '<form method="dialog" class="bl-readd__box">' +
        '<h3 id="bl-readd-title" class="bl-readd__title h6"></h3>' +
        '<p class="bl-readd__text"></p>' +
        '<div class="bl-readd__actions">' +
          '<button type="submit" value="primary" class="btn btn--primary bl-readd__btn" data-bl-readd="primary"><span class="btn__text"></span></button>' +
          '<button type="submit" value="secondary" class="btn btn--secondary bl-readd__btn" data-bl-readd="secondary"><span class="btn__text"></span></button>' +
        '</div>' +
        '<button type="submit" value="cancel" class="bl-readd__close" data-bl-readd="cancel" aria-label="">&times;</button>' +
      '</form>';
    document.body.appendChild(d);
    readdDialogEl = d;
    return d;
  }
  // Pregunta y resuelve con 'primary' | 'secondary' | 'cancel'. Sin <dialog> (navegadores viejos)
  // cae a window.confirm: aceptar = primera opción, cancelar = nada.
  function askReadd(texts) {
    return new Promise(function (resolve) {
      var d = null;
      try { d = readdDialog(); } catch (e) { d = null; }
      if (!d || typeof d.showModal !== 'function') {
        var okc = false;
        try { okc = window.confirm(texts.title + '\n\n' + texts.text + '\n\n' + texts.primary); } catch (e) { okc = false; }
        resolve(okc ? 'primary' : 'cancel');
        return;
      }
      d.querySelector('.bl-readd__title').textContent = texts.title;
      d.querySelector('.bl-readd__text').textContent = texts.text;
      d.querySelector('[data-bl-readd="primary"] .btn__text').textContent = texts.primary;
      d.querySelector('[data-bl-readd="secondary"] .btn__text').textContent = texts.secondary;
      d.querySelector('[data-bl-readd="cancel"]').setAttribute('aria-label', texts.cancel);
      d.returnValue = 'cancel';
      var done = false;
      function onClose() {
        if (done) return;
        done = true;
        d.removeEventListener('close', onClose);
        var v = d.returnValue;
        resolve(v === 'primary' || v === 'secondary' ? v : 'cancel');
      }
      d.addEventListener('close', onClose);
      try { d.showModal(); } catch (e) { done = true; resolve('cancel'); }
    });
  }

  // Vuelve a enviar el formulario con el mismo botón (el de la ficha o el de la barra fija), ya
  // con la decisión guardada. La marca `data-bl-readd-pass` hace que el captor lo deje pasar.
  function resubmitProductForm(form, submitter) {
    form.setAttribute('data-bl-readd-pass', '1');
    setTimeout(function () { form.removeAttribute('data-bl-readd-pass'); }, 0);
    try {
      if (typeof form.requestSubmit === 'function') {
        if (submitter && submitter.form === form && !submitter.disabled) form.requestSubmit(submitter);
        else form.requestSubmit();
        return;
      }
    } catch (e) {}
    var ev = new Event('submit', { bubbles: true, cancelable: true });
    if (form.dispatchEvent(ev) && !ev.defaultPrevented) form.submit();
  }

  function installReaddDialog(reg) {
    if (reg.readdDialogInstalled) return;
    reg.readdDialogInstalled = true;
    var pending = false;
    document.addEventListener('submit', function (e) {
      var form = e.target, split = null, mainId = null;
      try {
        if (!form || typeof form.matches !== 'function' || !form.matches('form[is="product-form"]')) return;
        if (form.getAttribute('data-bl-readd-pass') === '1') { form.removeAttribute('data-bl-readd-pass'); return; }
        var theme = window.FoxTheme;
        if (theme && theme.settings && theme.settings.cartType === 'page') return;   // carrito tipo página: envío real del formulario
        if (pending) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        var prov = reg.providers.get('bl-addons3:composite');
        if (!prov) return;
        var fd = new FormData(form);
        fd.append('sections', ''); fd.append('sections_url', window.location.pathname);
        var pl = prov.getBundlePayload({ body: fd });
        split = readdSplitAny(pl);
        if (!split) return;
        mainId = split.main.id;
      } catch (err) { return; }   // cualquier tropiezo: el tema sigue como siempre
      e.preventDefault(); e.stopImmediatePropagation();
      pending = true;
      var submitter = e.submitter || null;
      if (submitter && submitter.classList) submitter.classList.add('btn--loading');
      function finish(decision) {
        pending = false;
        if (submitter && submitter.classList) submitter.classList.remove('btn--loading');
        if (!decision) return;   // el cliente no quiere añadir: no pasa nada
        reg.readdDecision = { at: Date.now(), mainId: mainId, decision: decision };
        resubmitProductForm(form, submitter);
      }
      function tell(mode, choice) {
        try { document.dispatchEvent(new CustomEvent('bl:readd:dialog', { bubbles: true, detail: { mode: mode, choice: choice } })); } catch (err) {}
      }
      readCartForReadd(reg).then(function (cart) {
        var d;
        try { d = readdDecide(split, cart); } catch (err) { d = { mode: 'today' }; }
        var i18n = readdI18n() || {};
        if (d.mode === 'again') {
          return askReadd({
            title: i18n.again_title || 'Already in your cart',
            text: tpl(i18n.again_text || '{{ product }} is already in your cart. Add another one?', { product: cartLineName(d.hit.main) }),
            primary: i18n.again_yes || 'Yes, add another', secondary: i18n.view_cart || 'View cart', cancel: i18n.cancel || 'Cancel'
          }).then(function (choice) {
            tell('again', choice);
            if (choice === 'primary') return finish({ mode: 'again', items: d.items });
            if (choice === 'secondary') {
              try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })); } catch (err) {}
            }
            return finish(null);
          });
        }
        if (d.mode === 'swap') {
          // nombres en el orden del carrito (grifo, espejo), no en el del payload (que va invertido)
          var byRole = function (a, b) { return READD_NAME_ORDER.indexOf(bundleRole(a.properties)) - READD_NAME_ORDER.indexOf(bundleRole(b.properties)); };
          var oldNames = d.replaced.slice().sort(byRole).map(cartLineName).filter(Boolean);
          var newNames = d.items.filter(function (it) {
            var r = bundleRole(it.properties);
            return d.replaced.some(function (l) { return bundleRole(l.properties) === r; });
          }).sort(byRole).map(function (it) { return addonName(it.id, bundleRole(it.properties), i18n); });
          return askReadd({
            title: i18n.swap_title || 'This vanity is already in your cart',
            text: tpl(i18n.swap_text || "It's in there with {{ old }}. Swap it for {{ new }}, or add another set?", { old: joinNames(oldNames, i18n), new: joinNames(newNames, i18n) }),
            primary: i18n.swap_replace || 'Swap', secondary: i18n.swap_add || 'Add another set', cancel: i18n.cancel || 'Cancel'
          }).then(function (choice) {
            tell('swap', choice);
            if (choice === 'primary') return finish({ mode: 'swap', items: d.items, replaced: d.replaced });
            if (choice === 'secondary') return finish({ mode: 'today' });
            return finish(null);
          });
        }
        // nada que preguntar: el añadido sigue, con la decisión ya tomada (no se vuelve a leer el carrito)
        return finish(d.mode === 'attach' ? { mode: 'attach', items: d.items } : { mode: 'today' });
      }).then(null, function () { finish({ mode: 'today' }); });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('bl:grouping:swapped', init);
})();
